import React from 'react'
import Form from '../components/Home/Form'

function Contact() {
  return (
    <div>
      <Form/>  
    </div>
  )
}

export default Contact
